export default __webpack_public_path__ + "static/media/Labportalen_logo.07045ea2.png";